import { stages, values } from 'bundles/apex/deals/config';

export const orderedStages = [
  stages.pitching,
  stages.sourcing,
  stages.evaluating,
  stages.transacting,
  stages.closed,
  stages.dead,
];

export const restrictedOrderedStages = [
  stages.closed,
];

export function getOrderedStages(restricted) {
  return restricted ? restrictedOrderedStages : orderedStages;
}

export function getOrderedColumns(viewConfig, selectedBroker) {
  return [
    values.incomplete,
    values.displayName,
    values.identifier,
    values.location,
    values.dealTypeLabel,
    values.propertyTypeLabel,
    values.brokers,
    values.transactionValue,
    getGrossCommissionIncomeValue(values, viewConfig, selectedBroker),
    ...getConfiguredColumns(values, viewConfig),
  ];
}

function getConfiguredColumns(values, viewConfig) {
  const keys = viewConfig.columns?.length ? viewConfig.columns : defaultOptionalKeys;
  return keys.map(key => values[key]).filter(Boolean);
}

function getGrossCommissionIncomeValue(values, viewConfig, selectedBroker) {
  if (viewConfig?.brokerGross === 'weighted') {
    return selectedBroker ? values.weightedBrokerGrossCommissionIncome : values.weightedGrossCommissionIncome;
  } else {
    return selectedBroker ? values.brokerGrossCommissionIncome : values.grossCommissionIncome;
  }
}

export const defaultOptionalKeys = [
  'openTasks',
  'nextCriticalDate',
];

export const optionalKeys = [
  'address',
  'address2',
  'agreementTypeLabel',
  'buildingSize',
  'buyerTenant',
  'capRate',
  'closeDate',
  'closeProbability',
  'contractExecutionDate',
  'createdAt',
  'deadReason',
  'grossCommissionAmount',
  'grossCommissionPercent',
  'leaseExpirationDate',
  'leaseRate',
  'leaseStartDate',
  'leaseTermMonths',
  'leaseTypeLabel',
  'listingAssociation',
  'listingExecutionDate',
  'listingExpirationDate',
  'lotSizeAcres',
  'netOperatingIncome',
  'nextCriticalDate',
  'numberOfUnits',
  'occupancyPercent',
  'openTasks',
  'outsideCommissionAmount',
  'propertyName',
  'propertySubtypeLabel',
  'renewalOptionNoticeDate',
  'requirements',
  'sellerLandlord',
  'spaceSizeSf',
  'uncollectedAmount',
  'yearBuilt',
  'zip',
];
